import { makeStyles } from 'tss-react/mui';

export const stylesProspectReferral = makeStyles()((theme) => ({
  container: {
    padding: 20,
    marginBottom: 20,
    borderRadius: 5,
    backgroundColor: theme.palette.common.white,
  },
  footerContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    padding: 20,
  },
  divideMargin: {
    marginBottom: 10,
  },
  sectionMargin: {
    marginBottom: 15,
  },
  subHeader: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  borderError: {
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: 'red',
    },
  },
  tabs: {
    padding: 20,
    borderRadius: 20,
    border: 'solid 1px #d4d4d4',
    marginBottom: 5,
  },
  urlPreviewBox: {
    borderRadius: 4,
    border: '1px solid #C4C4C4',
    backgroundColor: '#f5f5f5',
    wordBreak: 'break-all',
    color: theme.palette.text.secondary,
    fontSize: '0.9rem',
  },
  customMentionInput: {
    '& textarea': {
      borderRadius: '4px',
      padding: '10px',
    },
    '& ul': {
      border: '1px solid #dedede',
    },
  },
  focusedMention: {
    backgroundColor: '#dedede',
  },
}));
